import { useState } from 'react';
import moment from 'moment';
import styled, { css } from 'styled-components';
import { Calendar, momentLocalizer } from 'react-big-calendar'
import { getClientSubdomain } from '../../utils';
import { eventsToCalendarEventFormatter } from '../SessionScheduleManager/sessionEventUtils';
import EventCardModal from '../EventCard/EventCardModal';

const localizer = momentLocalizer(moment)

// react-big-calendar needs an explicit height or an explicit height parent
const CalendarWrapper = styled.div`
  ${({ $view }) => !$view && css`
    height: calc(100vh - 330px);
  `}
  
  & .rbc-month-row {
    ${({ $view }) => $view === 'tall' && css`
      min-height: calc(18px + 23px * 10); // 18px top + 23px per row item (last item can get replaced with, "+x more")
    `}
  }
`

export default ({
  events
}) => {

  const clientSubdomain = getClientSubdomain()
  const isStarSubdomain = (clientSubdomain === 'star')

  const [date, setDate] = useState()
  const [eventModal, setEventModal] = useState()
  const [view, setView] = useState(isStarSubdomain ? 'tall' : undefined)

  const defaultDate = events?.[0]?.startTime || new Date()
  const calendarEvents = eventsToCalendarEventFormatter(events)

  // The calendar treats events ending at midnight as if they ended the day before.
  // Our events have dates, but no time, so their time will be treated as midnight (time 0).
  // We must add time so events don't end on midnight, otherwise their last day may not appear on the calendar.
  calendarEvents.forEach(e => {
    e.end = moment(e.end).add(1, 'second').toDate()
  })

  const eventPropGetter = (event, start, end, isSelected) => {
    return {
      style : {
        ...(['Tentative','Canceled'].includes(event.projectStatus) ? {
          color: '#3174ad',
          background: 'white',
          outline: 'solid 1px #3174ad'
        } : {})
      },
    };
  }

  const onEventSelected = (calendarEvent) => {
    const event = events.find(e => e.id === calendarEvent.id)
    setEventModal(event)
  }

  const CustomToolbar = (toolbar) => {
    return (
      <div className="rbc-toolbar">
        {/* Navigation Buttons (Today, Back, Next) */}
        <span className="rbc-btn-group">
          <button type="button" onClick={() => toolbar.onNavigate('TODAY')}>Today</button>
          <button type="button" onClick={() => toolbar.onNavigate('PREV')}>Back</button>
          <button type="button" onClick={() => toolbar.onNavigate('NEXT')}>Next</button>
        </span>

        {/* Current Label (e.g., "January 2026") */}
        <span className="rbc-toolbar-label">{toolbar.label}</span>

        {/* View Switchers (e.g. Month, Week, Day) */}
        <span className="rbc-btn-group">
          <button type="button" className={`${!view && 'rbc-active'}`} onClick={() => setView()}>Normal</button>
          <button type="button" className={`${view === 'tall' && 'rbc-active'}`} onClick={() => setView('tall')}>Tall</button>
        </span>
      </div>
    );
  };

  return (
    <CalendarWrapper $view={view}>
      <Calendar
        // Key is needed to force a re-render when the available height changes
        key={view}
        localizer={localizer}
        events={calendarEvents}
        defaultDate={defaultDate}
        date={date}
        onNavigate={(newDate) => setDate(newDate)}
        defaultView={'month'}
        onSelectEvent={onEventSelected}
        eventPropGetter={eventPropGetter}
        components={{
          toolbar: CustomToolbar
        }}
        popup
        resizable
      />
      {eventModal &&
        <EventCardModal eventData={eventModal} onClose={() => setEventModal(undefined)} />
      }
    </CalendarWrapper>
  )
}